/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface QueryAttributeValuesBodyDTO
 */
export interface QueryAttributeValuesBodyDTO {
    /**
     * Required attribute name
     * @type {string}
     * @memberof QueryAttributeValuesBodyDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof QueryAttributeValuesBodyDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * Optional limit of returned values
     * @type {number}
     * @memberof QueryAttributeValuesBodyDTO
     */
    limit?: number;
    /**
     * Optional regex value filter; used only for `string` attributes
     * @type {string}
     * @memberof QueryAttributeValuesBodyDTO
     */
    regexValueFilter?: string;
}



/**
 * Check if a given object implements the QueryAttributeValuesBodyDTO interface.
 */
export function instanceOfQueryAttributeValuesBodyDTO(value: object): value is QueryAttributeValuesBodyDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function QueryAttributeValuesBodyDTOFromJSON(json: any): QueryAttributeValuesBodyDTO {
    return QueryAttributeValuesBodyDTOFromJSONTyped(json, false);
}

export function QueryAttributeValuesBodyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryAttributeValuesBodyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'regexValueFilter': json['regexValueFilter'] == null ? undefined : json['regexValueFilter'],
    };
}

export function QueryAttributeValuesBodyDTOToJSON(value?: QueryAttributeValuesBodyDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'limit': value['limit'],
        'regexValueFilter': value['regexValueFilter'],
    };
}

